import { useEffect, useState } from 'react';

export function useIsNarrowScreen() {
  const [isNarrow, setIsNarrow] = useState(
    () => window.matchMedia('(max-width: 1008px)').matches
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 1008px)');

    const handler = (e: MediaQueryListEvent) => setIsNarrow(e.matches);
    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  return isNarrow;
}
